import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_rule_outbound_order_processing_rules_grid___rule_outbound_order_processing_rules_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, name?: string, description?: string, owner_ids?: number[], project_ids?: number[], warehouse_ids?: number[], order_class_ids?: number[], is_active?: boolean, processing_strategy_workflow_code?: string, cartonization_strategy_workflow_code?: string, expand_order_line_kits?: boolean, created_on?: string, created_by?: string, modified_on?: string, modified_by?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { full_text_search?: string, $keys: string[] }): Promise<{ result?: { id?: string, name?: string, description?: string, owner_ids?: number[], project_ids?: number[], warehouse_ids?: number[], order_class_ids?: number[], is_active?: boolean, processing_strategy_workflow_code?: string, cartonization_strategy_workflow_code?: string, expand_order_line_kits?: boolean, created_on?: string, created_by?: string, modified_on?: string, modified_by?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      full_text_search?: string    }) {
      return false;
    }
}
